export default __webpack_public_path__ + "static/media/pier39Klein.a91aaadc.jpg";